import { render } from "./MinglyApp.vue?vue&type=template&id=546dac06&scoped=true"
import script from "./MinglyApp.vue?vue&type=script&lang=js"
export * from "./MinglyApp.vue?vue&type=script&lang=js"

import "./MinglyApp.vue?vue&type=style&index=0&id=546dac06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546dac06"]])

export default __exports__